var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9999 2C10.1434 2 8.36294 2.7375 7.05018 4.05025C5.73743 5.36301 4.99993 7.14348 4.99993 9V12.528C5.00008 12.6831 4.96413 12.8362 4.89493 12.975L3.17793 16.408C3.09406 16.5757 3.05445 16.7621 3.06288 16.9494C3.07131 17.1368 3.12748 17.3188 3.22608 17.4783C3.32467 17.6379 3.4624 17.7695 3.6262 17.8608C3.78999 17.9521 3.97441 18 4.16193 18H19.8379C20.0255 18 20.2099 17.9521 20.3737 17.8608C20.5375 17.7695 20.6752 17.6379 20.7738 17.4783C20.8724 17.3188 20.9286 17.1368 20.937 16.9494C20.9454 16.7621 20.9058 16.5757 20.8219 16.408L19.1059 12.975C19.0364 12.8362 19.0001 12.6832 18.9999 12.528V9C18.9999 7.14348 18.2624 5.36301 16.9497 4.05025C15.6369 2.7375 13.8564 2 11.9999 2ZM11.9999 21C11.3793 21.0003 10.7738 20.8081 10.2669 20.4499C9.76009 20.0917 9.37681 19.5852 9.16993 19H14.8299C14.623 19.5852 14.2398 20.0917 13.7329 20.4499C13.2261 20.8081 12.6206 21.0003 11.9999 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c629153e1744ca17d13d20d9a9585b43.svg";
export { ForwardRef as ReactComponent };